import { useState } from "react"
import Button, {
  type ButtonProps,
} from "@/v2-backoffice-client/components/button"
import UserCreateManyDialog from "@/v2-backoffice-client/user/create/many/UserCreateManyDialog"

export type UserCreateManyButtonProps = ButtonProps & {
  defaultTenantId?: number
  defaultTenantName?: string
}

function UserCreateManyButton(props: UserCreateManyButtonProps) {
  const {
    defaultTenantId,
    defaultTenantName,
    onClick,
    children,
    ...buttonProps
  } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Button
        variant="primary"
        size="tiny"
        iconSrc="user-add"
        iconSize={12}
        onClick={(e) => {
          setIsOpen(true)
          onClick?.(e)
        }}
        {...buttonProps}
      >
        {children ?? "Create users"}
      </Button>

      <UserCreateManyDialog
        defaultTenantId={defaultTenantId}
        defaultTenantName={defaultTenantName}
        open={isOpen}
        onOpenChange={setIsOpen}
      />
    </>
  )
}

export default UserCreateManyButton
